import React from "react";
import {
  Box,
  Button,
  Container,
  Typography,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import theme from "../../../theme/Theme";
import referralBg from "../../../assets/images/referral_info.webp";

const Referral = () => {
  const navigate = useNavigate();
  const muiTheme = useTheme();
  const isMobile = useMediaQuery(muiTheme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(muiTheme.breakpoints.between("sm", "md"));

  return (
    <Box sx={styles.section}>
      <Container maxWidth="lg" sx={{ px: { xs: 0, sm: 3 } }}>
        <Box sx={styles.contentWrapper}>
          <Box sx={styles.imageBox}></Box>
          <Box sx={styles.overlay}>
            <Box
              sx={{
                maxWidth: { xs: "90%", sm: "85%", md: 600 },
                padding: { xs: "20px 10px", sm: "20px", md: 0 },
              }}
            >
              <Typography sx={styles.title}>
                Share a Link. Get Paid in USDT. Instantly.
              </Typography>
              <Typography sx={styles.description}>
                Join the only blockchain-powered draw referral program where you
                earn in seconds. No crypto tokens. Just real, stable USDT.
              </Typography>
              <Button
                variant="contained"
                onClick={() => navigate("/referrals")}
                sx={{
                  ...styles.ctaButton,
                  fontSize: isMobile
                    ? "0.9rem"
                    : isTablet
                    ? "1.1rem"
                    : "1.2rem",
                  padding: isMobile ? "8px 20px" : "10px 24px",
                  width: { xs: "100%", sm: "auto" },
                }}
                fullWidth={isMobile}
              >
                Connect Wallet Now
              </Button>
            </Box>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

const styles = {
  section: {
    padding: { xs: "30px 0", sm: "60px 0", md: "80px 0" },
    position: "relative",
    background: `linear-gradient(135deg, ${theme.palette.primary.light} 0%, ${theme.custom.white} 100%)`,
    overflow: "hidden",
  },
  contentWrapper: {
    position: "relative",
    borderRadius: { xs: 0, sm: "8px" },
    overflow: "hidden",
    // boxShadow: { xs: "none", sm: "0 8px 24px rgba(0,0,0,0.1)" },
  },
  imageBox: {
    backgroundImage: `url(${referralBg})`,
    backgroundSize: "cover",
    // backgroundPosition: { xs: "top center", sm: "center" },
    width: { xs: "100%", sm: "100%" },
    height: { xs: "300px", sm: "400px", md: "500px" },
    minHeight: "300px",
  },
  overlay: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: { xs: "flex-start", md: "flex-start" },
    justifyContent: { xs: "center", md: "center" },
    textAlign: { xs: "center", md: "left" },
    padding: { xs: "0 0 0 10px", md: "0 0 0 60px" },
  },
  title: {
    fontSize: { xs: "1rem", sm: "1rem", md: "2.5rem" },
    fontWeight: 800,
    color: "#fff",
    marginBottom: { xs: "12px", md: "20px" },
    lineHeight: { xs: 1.3, md: 1.2 },
    textShadow: "0 2px 4px rgba(0,0,0,0.3)",
  },
  description: {
    fontSize: { xs: "0.95rem", sm: "1.1rem", md: "1.2rem" },
    color: "#fff",
    marginBottom: { xs: "20px", md: "30px" },
    lineHeight: 1.5,
    textShadow: "0 1px 2px rgba(0,0,0,0.3)",
  },
  ctaButton: {
    backgroundColor: "#FFFFFF",
    color: theme.palette.primary.main,
    fontWeight: 600,
    textTransform: "uppercase",
    "&:hover": {
      backgroundColor: "#f5f5f5",
      transform: "translateY(-2px)",
      boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
    },
    transition: "all 0.3s ease",
    borderRadius: "8px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
    mb: { xs: 1, md: 0 },
  },
};

export default Referral;
